import React, { useEffect, useState } from 'react';
import styles from './send_message.module.css';
import animations from '../../../../styles/animations.module.css';
import api from '../../../../services/api';

const SendMessage = () => {
  const isLoggedIn = localStorage.getItem('token') !== null;
  const user = isLoggedIn ? JSON.parse(localStorage.getItem('user')) : null;
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: isLoggedIn ? `${user?.firstName} ${user?.lastName}` : '',
    email: isLoggedIn ? user?.email : '',
    subject: '',
    message: '',
    category: '' // Empty default category
  });

  // Available ticket categories
  const ticketCategories = [
    'Technical Issue',
    'Account',
    'Billing',
    'Feature Request',
    'Product Question',
    'Other'
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSubmitStatus({ type: '', message: '' });

    try {
      const messageData = {
        ...formData,
        user_id: isLoggedIn ? user.id : null
      };

      const response = await api.post('/contact', messageData);

      if (response.data.status === 'success') {
        setSubmitStatus({
          type: 'success',
          message: 'Message sent successfully! We will get back to you soon.'
        });
        
        // Clear form if submission was successful
        if (!isLoggedIn) {
          setFormData({
            name: '',
            email: '',
            subject: '',
            message: '',
            category: ''
          });
        } else {
          setFormData({
            ...formData,
            subject: '',
            message: '',
            category: ''
          });
        }
      }
    } catch (error) {
      console.error('Error details:', error);
      setSubmitStatus({
        type: 'error',
        message: error.message || 'Failed to send message'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.sendMessage}>
      <div className={styles.hero}>
        <div className={`${styles.heroContent} ${animations.animate} ${animations.fadeInUp}`}>
          <h1>Contact Us</h1>
          <p>Get in touch with our support team for assistance</p>
        </div>
      </div>

      <div className={styles.contactSection}>
        <div className={styles.container}>
          <div className={styles.contactGrid}>
            <div className={`${styles.contactInfo} ${animations.animate} ${animations.fadeInLeft}`}>
              <h2>Get in Touch</h2>
              <p>Our support team is here to help you with any questions or concerns.</p>
              
              <div className={styles.infoItems}>
                <div className={styles.infoItem}>
                  <i className="fas fa-clock"></i>
                  <div>
                    <h3>Response Time</h3>
                    <p>Within 24 hours</p>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <i className="fas fa-phone"></i>
                  <div>
                    <h3>Phone Support</h3>
                    <p>Monday - Friday, 9AM - 6PM EST</p>
                  </div>
                </div>

                <div className={styles.infoItem}>
                  <i className="fas fa-envelope"></i>
                  <div>
                    <h3>Email</h3>
                    <p>support@constructio.com</p>
                  </div>
                </div>
              </div>
            </div>

            <div className={`${styles.contactForm} ${animations.animate} ${animations.fadeInRight}`}>
              <h2>Send Message</h2>
              
              {submitStatus.message && (
                <div className={`${styles.statusMessage} ${styles[submitStatus.type]}`}>
                  {submitStatus.message}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                {!isLoggedIn && (
                  <>
                    <div className={styles.formGroup}>
                      <label htmlFor="name">Full Name</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className={styles.formGroup}>
                      <label htmlFor="email">Email Address</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </>
                )}

                <div className={styles.formGroup}>
                  <label htmlFor="category">Category</label>
                  <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                    className={styles.categorySelect}
                  >
                    <option value="" disabled>Select a category</option>
                    {ticketCategories.map(category => (
                      <option key={category} value={category}>
                        {category}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="6"
                    required
                  ></textarea>
                </div>

                <button type="submit" className={styles.submitButton} disabled={loading}>
                  {loading ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendMessage; 